import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";

// AU workbook import — preview (per-tab row counts + headers the importer couldn't place) before anything is written.
export function ImportPreviewDialog({ preview, busy, onConfirm, onClose }) {
  if (!preview) return null;
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg" data-testid="import-preview-dialog">
        <DialogHeader>
          <DialogTitle>Import the collection report workbook</DialogTitle>
          <DialogDescription>{preview.rows} days found · {preview.first} → {preview.last}. Sheet figures become the record for those days; portal-locked rows only have their blanks filled.</DialogDescription>
        </DialogHeader>
        <div className="max-h-64 overflow-auto rounded-md border border-slate-200 text-xs">
          <table className="w-full">
            <thead className="bg-slate-50 text-[11px] text-slate-600"><tr><th className="px-2 py-1 text-left">Tab</th><th className="px-2 py-1 text-right">Rows</th><th className="px-2 py-1 text-left">Columns placed</th></tr></thead>
            <tbody>
              {(preview.sheets || []).map((s) => (
                <tr key={s.sheet} className="border-t border-slate-100" data-testid={`import-sheet-${s.sheet}`}>
                  <td className="px-2 py-1 font-medium">{s.sheet}</td>
                  <td className="px-2 py-1 text-right font-mono">{s.rows}</td>
                  <td className="px-2 py-1 text-slate-500">{(s.columns || []).length} fields{s.unmapped?.length ? <span className="ml-1 text-rose-600">· couldn't place: {s.unmapped.join(", ")}</span> : null}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {preview.unmapped?.length > 0 && (
          <p className="text-[11px] text-rose-600" data-testid="import-unmapped">Headers not recognised (those columns are skipped): {preview.unmapped.join(", ")}</p>
        )}
        <DialogFooter>
          <Button variant="ghost" size="sm" onClick={onClose} disabled={busy}>Cancel</Button>
          <Button size="sm" className="bg-slate-900 hover:bg-slate-800" onClick={onConfirm} disabled={busy} data-testid="import-confirm">
            {busy ? <Loader2 className="w-3.5 h-3.5 mr-1.5 animate-spin" /> : null}Import {preview.rows} days
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
